module.exports = __webpack_public_path__ + "static/media/Sharp-Product-Custom-Camera-Modules.4ec53ec8.jpg";